<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .carousel-container {
    width: calc(100% + utils.in_rem(40px));
    overflow: hidden;
    position: relative;
    height: utils.in_rem(55px);
    margin-top: utils.in_rem(60px);
    display: flex;
    justify-content: center;

    .carousel-track {
      display: flex;
      align-items: center;
      gap: utils.in_rem(80px);
      animation: scroll 20s linear infinite;
      will-change: transform;
      width: max-content;
    }

    .logo-item {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        height: 100%;
        width: auto;
        object-fit: contain;
        transition: filter 0.3s ease;
      }
    }
  }

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-33.333%);
    }
  }
</style>

<script>
  import boydenLogo from "../../../../assets/img/signup/boyden.png";
  import geLogo from "../../../../assets/img/signup/ge-partners.png";
  import meetLogo from "../../../../assets/img/signup/meet.png";
  import recruithubLogo from "../../../../assets/img/signup/recruithub.png";
  import robertHalfLogo from "../../../../assets/img/signup/robert-half.png";
  import stottMayLogo from "../../../../assets/img/signup/stott-may.png";
  import strativLogo from "../../../../assets/img/signup/strativ.png";

  const baseLogos = [
    { src: stottMayLogo, alt: "Stott & May", height: "55px", width: "55px" },
    { src: strativLogo, alt: "Strativ", height: "21px", width: "86px" },
    { src: recruithubLogo, alt: "RecruitHub", height: "39px", width: "153px" },
    { src: robertHalfLogo, alt: "Robert Half", height: "22px", width: "160px" },
    { src: meetLogo, alt: "Meet", height: "29px", width: "93px" },
    { src: boydenLogo, alt: "Boyden", height: "32px", width: "112px" },
    { src: geLogo, alt: "GE Partners", height: "31px", width: "115px" },
  ];

  // Triple logos for seamless infinite scroll
  const logos = [...baseLogos, ...baseLogos, ...baseLogos];
</script>

<div class="carousel-container">
  <div class="carousel-track">
    {#each logos as logo}
      <div
        class="logo-item"
        style="height: {logo.height}; width: {logo.width};"
      >
        <img src={logo.src} alt={logo.alt} />
      </div>
    {/each}
  </div>
</div>
